<template>
    <div class="private-hero">
        <video
            ref="video"
            autoplay muted playsinline
            class="private-hero__video"
        >
            <source data-src="/local/templates/redesign/src/assets/img/private/hero/1stblock_video_compress.webm" type="video/webm" >
        </video>
        <div class="private-hero__bg">
            <PrivateHeroBg
                :lights="lights"
                @click="onClick"
            />
        </div>
        <transition-group name="private-banking__transition_fade">
            <div
                v-if="isShowedContent"
                key="head-title"
                class="private-hero__head"
            >
                <div class="container">
                    <slot name="head" />
                </div>
            </div>
            <div
                v-if="isShowedContent"
                key="head-cta"
                class="private-hero__cta"
            >
                <div class="container">
                    <slot name="cta" />
                </div>
            </div>
            <div
                v-if="isShowedContent"
                key="content"
                class="private-hero__content"
            >
                <div
                    v-for="(item, i) in lights"
                    :key="i"
                    class="private-hero__content-item"
                    :style="contentPositionsVars[i]"
                >
                        <!-- @click.prevent="onClick(i)" -->
                    <a
                        class="h4"
                        :href="item.anchor"
                        v-js-anchor
                    >{{ item.text }}</a>
                </div>
            </div>
        </transition-group>
    </div>
</template>
<script>
import { ref } from 'vue';
import { useResize } from '../../assets/js/vue/utlis/useResize';
import PrivateHeroBg from './PrivateHeroBg.vue';
import { scrollToElem } from '../../assets/js/utils';

export default {
    name: 'PrivateHero',
    components: {
        PrivateHeroBg,
    },
    setup() {
        const isMobile = ref(window.innerWidth <= 1000);

        useResize(() => {
            isMobile.value = window.innerWidth <= 1000;
        }, true);

        return {
            isMobile,
        };
    },
    data() {
        return {
            /**
             * Параметры позиции кружков и текста на орбите
             * @type {Light[]}
             * @property {number} Light.deg - отклонение кружка в градусах против часовой стрелке, где 0 - позиция на 12 часов
             * @property {number} Light.r - радиус орбиты на которой располагается кружок
             * @property {number} Light.top - отступ текста от края блока сверху
             * @property {number} Light.left - отступ текста от края блока слева
             * @property {number} Light.text - текст
             * @property {number} Light.anchor - ссылка
             */
            lights: [
                {
                    deg: 103,
                    r: 338,
                    top: 760,
                    left: 679,
                    text: 'Кредиты и ипотека',
                    anchor: '#private-products-credits',
                },
                {
                    deg: 295,
                    r: 338,
                    top: 541,
                    left: 1310,
                    text: 'Лайфстайл и развлечения',
                    anchor: '#private-lifestyle',
                },
                {
                    deg: 258,
                    r: 338,
                    top: 751,
                    left: 1336,
                    text: 'Инвестиции и Wealth Management',
                    anchor: '#private-investment',
                },
                {
                    deg: 76.5,
                    r: 556,
                    top: 556,
                    left: 470,
                    text: 'Вклады и счета',
                    anchor: '#private-products-deposits',
                },
            ],
            /**
             * Состояние видимости блока во вьюпорте
             */
            cardBgInViewport: false,
            isShowedContent: false,
        };
    },
    computed: {
        contentPositionsVars() {
            return this.lights.map(({ top, left }) => ({
                '--private-hero__content-item-top': top,
                '--private-hero__content-item-left': left,
            }));
        },
    },
    methods: {
        onClick(i) {
            const elId = this.lights[i].anchor.slice(1);
            if (!elId) return;

            scrollToElem(elId);
        },
    },
    mounted() {

        setTimeout(() => {
            this.isShowedContent = true;
        }, 1000);

        Array.from(this.$refs.video.children).forEach((item) => {
            item.src = item.dataset.src;
        });
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/mixins';
@import '../../assets/scss/base/functions';

.private-hero {
    position: relative;

    @include not-mobile {
        @include fluid-1920('height', 1252px);
    }

    @include mobile {
        @include fluid-1920('min-height', 594px);
    }

    &__video {
        position: absolute;
        @include fluid-1920('top', 405px, 275px);
        @include fluid-1920('left', 237px, 0px);
        @include fluid-1920('width', 1440px, 360px);
        @include fluid-1920('height', 657px, 217px);
        object-fit: cover;
        object-position: top center;

        mask-repeat: no-repeat;
        mask-image: radial-gradient(50% 50% at 50% 50%, black 40%, rgba(0, 0, 0, 0) 100%);
        mask-mode: alpha;

        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('/local/templates/redesign/src/assets/img/private/hero/hero_bg.webp');

        @include mobile {
            background-image: url('/local/templates/redesign/src/assets/img/private/hero/video-bg_mob.webp');

            @include retina {
                background-image: url('/local/templates/redesign/src/assets/img/private/hero/video-bg_mob@2.webp');
            }
        }
    }

    &__bg {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
    }

    &__head {
        @include fluid('padding-top', 218px, 155px);
        @include fluid('margin-bottom', 40px, 215px);
        position: relative;
    }

    &__content {
        position: absolute;
        top: 0px;
        left: 0px;

        @include mobile {
            display: none;
        }
    }

    &__content-item {
        cursor: pointer;
        position: absolute;
        @include fluid('width', 222px);
        top: calc(var(--private-hero__content-item-top) / 1920 * 100vw);
        left: calc(var(--private-hero__content-item-left) / 1920 * 100vw);
    }
}
</style>
